module.exports = __webpack_public_path__ + "img/zuowen_app_view.579b11fc.png";